var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":_vm.route,"tag":"div"}},[_c('div',{staticClass:"side-nav-header"},[_c('div',{staticClass:"logo"},[_vm._t("icon")],2),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }